import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { MdArrowDropDown } from 'react-icons/md';
import styles from './input-dropdown.module.css';

class InputSelectDropdown extends Component {
  captureValue = event => {
    const selectValue = event.target.innerHTML;
    this.props.updateSelectData(selectValue);
    this.props.toggleSelect();
  };

  handleClick = event => {
    if (!this.node.contains(event.target)) {
      this.props.toggleSelect();
    }
  };

  componentWillMount() {
    document.addEventListener('mousedown', this.handleClick, false);
  }

  componentWillUnmount() {
    document.removeEventListener('mousedown', this.handleClick, false);
  }
  render() {
    return (
      <div ref={node => (this.node = node)} className={styles.dropdown}>
        <span className={styles.title}>{this.props.placeholder} </span>
        <span className={styles.icon}>
          <MdArrowDropDown />
        </span>
        <ul className={styles.list}>
          {this.props.options.map((option, index) => {
            return (
              <li
                key={index}
                className={styles.item}
                onClick={event => this.captureValue(event)}
              >
                {option.value}
              </li>
            );
          })}
        </ul>
      </div>
    );
  }
}

InputSelectDropdown.propTypes = {
  updateSelectData: PropTypes.func,
  toggleSelect: PropTypes.func,
};

export default InputSelectDropdown;



// WEBPACK FOOTER //
// ./src/components/form/inputs/input-select/input-dropdown/index.js